var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279.63 279.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00427c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.11,268.83C46.09,256.3-1.49,188.28,11,117.2S91.51-1.5,162.52,11,281.12,91.58,268.6,162.66,188.12,281.36,117.11,268.83ZM2.14,115.64c-13.38,76,37.48,148.69,113.4,162.09s148.56-37.53,162-113.5a140.61,140.61,0,0,0,2.14-24.37c0-66.59-47.8-125.76-115.54-137.72C88.18-11.26,15.52,39.66,2.14,115.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    className: "cls-1",
    d: "M141.39,214.57V146.48h22.86l3.42-26.54H141.39V103c0-7.69,2.14-12.92,13.16-12.92h14V66.34a185.7,185.7,0,0,0-20.48-1c-20.26,0-34.13,12.37-34.13,35.08v19.57H91.07v26.54H114v68.09Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c806ae0c3b3da72834f02879d6664e55.svg";
export { ForwardRef as ReactComponent };